<main class="auth auth--centered">
  <section class="auth__panel auth__panel--wide">
    <div class="auth__card auth__card--centered">

      <span class="auth__mark-mobile">
        <svg width="44" height="44" viewBox="0 0 120 120" fill="none" aria-hidden="true">
          <defs>
            <clipPath id="frameReset"><rect x="28.5" y="20.5" width="63" height="79" rx="15.5"></rect></clipPath>
          </defs>
          <rect x="26" y="18" width="68" height="84" rx="18" stroke="#1F4B3F" stroke-width="4.5"></rect>
          <g clip-path="url(#frameReset)">
            <circle cx="46.5" cy="44" r="8.5" stroke="#C2A461" stroke-width="3.6"></circle>
            <path d="M27 83 L43 66 L52 72 L70 48 L93 83" stroke="#1F4B3F" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"></path>
            <path d="M26 87 Q43 79 60 87 T95 87" stroke="#1F4B3F" stroke-width="3.6" stroke-linecap="round"></path>
            <path d="M26 96 Q45 87 62 96 T98 95" stroke="#C2A461" stroke-width="3.6" stroke-linecap="round"></path>
          </g>
        </svg>
      </span>

      <!-- The form -->
      <div data-id="reset-request">
        <p class="auth__eyebrow">SaaS Admin</p>
        <h2 class="auth__title"><%= _lcs( 'Neues Passwort vergeben' ) %></h2>
        <p class="auth__subtitle"><%= _lcs( 'Wähle ein neues Passwort für dein Konto.' ) %></p>

        <form class="auth__form" data-id="reset-form" autocomplete="on" novalidate>
          <!-- Lets password managers file the new password under the right account. -->
          <input type="email" name="username" autocomplete="username" value="<%= email %>" hidden />

          <div class="field">
            <label class="field__label" for="reset-new"><%= _lcs( 'Neues Passwort' ) %></label>
            <div class="field__control">
              <span class="field__icon"><i class="icon icon--key-round"></i></span>
              <input class="field__input" id="reset-new" name="newPassword" type="password"
                     autocomplete="new-password" minlength="<%= minLength %>" required />
              <button class="field__toggle" type="button" data-toggle="reset-new"
                      aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
                <i class="icon icon--eye"></i>
              </button>
            </div>
            <span class="field__hint"><%= _lcs( 'Mindestens {count} Zeichen.', { count: minLength } ) %></span>
          </div>

          <div class="field">
            <label class="field__label" for="reset-repeat"><%= _lcs( 'Neues Passwort wiederholen' ) %></label>
            <div class="field__control">
              <span class="field__icon"><i class="icon icon--key-round"></i></span>
              <input class="field__input" id="reset-repeat" name="repeatPassword" type="password"
                     autocomplete="new-password" required />
              <button class="field__toggle" type="button" data-toggle="reset-repeat"
                      aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
                <i class="icon icon--eye"></i>
              </button>
            </div>
          </div>

          <p class="auth__error" data-id="reset-error" role="alert" hidden></p>

          <button class="btn btn--primary btn--block" type="submit">
            <i class="icon icon--check"></i>
            <%= _lcs( 'Passwort speichern' ) %>
          </button>
        </form>
      </div>

      <!-- Done -->
      <div data-id="reset-done" hidden>
        <span class="auth__status"><i class="icon icon--circle-check"></i></span>
        <h2 class="auth__title"><%= _lcs( 'Passwort geändert' ) %></h2>
        <p class="auth__subtitle"><%= _lcs( 'Dein neues Passwort ist gespeichert. Aus Sicherheitsgründen wurdest du auf allen Geräten abgemeldet.' ) %></p>
        <button class="btn btn--primary btn--block" type="button" data-id="btn-to-login">
          <%= _lcs( 'Zur Anmeldung' ) %>
          <i class="icon icon--arrow-right"></i>
        </button>
      </div>

      <a class="auth__link auth__back" href="#/login" data-id="btn-back-to-login">
        <i class="icon icon--arrow-left"></i>
        <%= _lcs( 'Zurück zur Anmeldung' ) %>
      </a>

      <div class="auth__hr"><%= _lcs( 'Geschützter Bereich' ) %></div>
      <p class="auth__note"><%= _lcs( 'BELTURO Cloud — Interner Operator-Zugang.' ) %></p>
    </div>
  </section>
</main>
